import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NavService } from 'src/app/services/nav.service';
import { SpacesSwitcherService } from 'src/app/services/spaces-switcher.service';
import {
  PencilButtonComponent,
  PencilButtonThemeEnum,
} from 'src/app/standalones/components/pencil-button/pencil-button.component';
import { IconTypes } from 'src/app/standalones/components/pencil-icon/pencil-icon.component';

/**
 * Chevron in the sidebar header that collapses the Spaces Switcher sidebar. Renders itself only
 * with the switcher enabled and a space open (there's nothing beside the sidebar to collapse onto
 * otherwise); it's re-opened from the whiteboard's "more" tool button, which reappears while
 * collapsed. Self-gating so the nav bar carries no switcher state for it.
 */
@Component({
  selector: 'app-nav-sidebar-collapse-button',
  standalone: true,
  imports: [CommonModule, TranslateModule, PencilButtonComponent],
  templateUrl: './nav-sidebar-collapse-button.component.html',
  styleUrls: ['./nav-sidebar-collapse-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavSidebarCollapseButtonComponent {
  readonly isSwitcherEnabled$ = this.spacesSwitcherService.isEnabled$;
  readonly currentSpaceId$ = this.spacesSwitcherService.currentSpaceId$;

  protected readonly IconTypes = IconTypes;
  protected readonly PencilButtonThemeEnum = PencilButtonThemeEnum;

  constructor(
    private navService: NavService,
    private spacesSwitcherService: SpacesSwitcherService,
  ) {}

  collapseSidebar(): void {
    this.navService.isMenuOpened.next(false);
  }
}
